import { useQuery } from '@tanstack/react-query';
import api from '@api-client/client';
import { ListDataParams } from '@api-client/types';

const useContactTypes = (
  type: 'company' | 'individual' | 'task-client',
  listData?: ListDataParams
) => {
  return useQuery({
    queryKey: ['contactTypes', type],
    queryFn: async () => {
      const data = await api.types.getContactTypes(type, listData);

      // Filter out "Employee" from company types only
      if (type === 'company') {
        return data.filter((contactType) => contactType.name !== 'Employee');
      }

      return data;
    }
  });
};

export default useContactTypes;
